import { firebaseAuth } from "@/infrastructure/firebase";

import React, { useState } from "react";
import { Button, Card, Checkbox, Col, Form, Input, Row, Typography } from "antd";
import { Link, useHistory } from "react-router-dom";
import styles from "./styles.less";
import { LockOutlined, MailOutlined } from "@ant-design/icons/lib";

const { Text } = Typography;

export default () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();

  return (
    <div className={styles.loginBackground}>
      <Row justify="center" align="middle" style={{ height: "100%", marginTop: "-80px" }}>
        <Col style={{ width: 400 }}>
          <Card style={{ borderRadius: 15 }} title={"Login"}>
            <Form onFinish={login} form={form} className="login-form">
              <Form.Item name="email" rules={[{ required: true, message: "Please input your email!" }]}>
                <Input prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />} placeholder="Email" />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: "Please input your Password!" }]}>
                <Input
                  prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item initialValue={true}>
                <Checkbox>Remember me</Checkbox>
                <a className={styles.loginForgot} href="">
                  Forgot password
                </a>
                <Button type="primary" htmlType="submit" className={styles.loginButton} loading={loading}>
                  Log in
                </Button>
                Or <Link to="/register">register now!</Link>
              </Form.Item>
              {error.length > 0 && <Text type="danger">{error}</Text>}
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );

  function login() {
    const { email, password } = form.getFieldsValue();
    setError("");
    setLoading(true);
    firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then(_cred => {
        history.push("/");
      })
      .catch(e => {
        setError(e.message);
        setLoading(false);
      });
  }
};
